import styled from 'styled-components'

import lockIcon from './asssets/lock_icon.svg'

import type { StyledToggleInputProps } from './types'

export const ToggleContainer = styled.div<StyledToggleInputProps>`
  color: ${({ $disabled, theme }) =>
    $disabled ? theme.colors.slateGray : theme.colors.sapphireDark};
  background-color: ${({ $disabled, theme }) =>
    $disabled ? theme.colors.catskillWhite : theme.colors.white};
  border: ${({ $disabled, theme }) =>
    $disabled && `1px solid ${theme.colors.crystalBay}`};
  padding: 13px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
`

export const ToggleCaptionContainer = styled.div`
  margin-left: 16px;
  font-family: ${({ theme }) => theme.fonts.mainFont};
  font-weight: normal;

  b {
    font-weight: bold;
  }
`

export const Toggle = styled.label`
  height: 22px;
  width: 40px;
  min-width: 40px;
  padding: 0;
  border: none;
  border-radius: 10.5px;
  position: relative;
  margin-bottom: 0;

  :hover span {
    background: ${({ theme }) => theme.colors.slateGray};
  }

  :hover input:disabled + span {
    cursor: not-allowed;
  }

  input {
    display: none;
  }

  span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 10.5px;
    background-color: ${({ theme }) => theme.colors.catsBorderColor};
    transition: background 200ms ease-in-out;
  }

  span::before {
    position: absolute;
    content: '';
    height: 18px;
    width: 18px;
    left: 2px;
    bottom: 2px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.white};
    transition: transform 200ms ease-in-out;
  }

  input:checked + span {
    background-color: ${({ theme }) => theme.colors.sapphireDark};
  }

  input:checked + span::before {
    transform: translateX(18px);
  }
`

export const LockIcon = styled.div`
  position: absolute;
  top: -4px;
  right: -1px;
  width: 14px;
  height: 14px;
  background-image: url(${lockIcon});
  background-position: center;
  background-size: 14px;
  background-repeat: no-repeat;
`
